export const UNIVERSAL_LOGIN_WITH_EMAIL_OTP = '2_Step_sign_up_and_sign_in_BEX_NON_CKO_IN_EGTNL';
export const ACCOUNT_MERGE_IDENTITY_ONBOARDING_V2 = 'Onboarding_v2_Web';
export const KOREA_SOCIAL_AUTH_EGTNL = 'KR_Consents_SocialPopUps_WEB';
export const EG_ID_UL_SOCIAL_AUTH = 'EG_ID_UL_SOCIAL_AUTH';
export const UL_SHARED_UI_MIGRATION_VERIFY_OTP_PASSWORD = 'UL_Migration_SharedUI_Verify_OTP_And_Password';
export const UL_SHARED_UI_MIGRATION_ADD_USER_DETAILS = 'UL_Migration_SharedUI_Add_User_Details';
export const NAVER_SOCIAL_LOGIN = 'Naver_Social_Implementation';
